export default "__VITE_ASSET__BMvuwQFp__"